import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { listRequest, updateRequest } from 'core/services/admin';
import { update } from 'core/actions/admin/data';
import { ITheme } from 'types/domain/organisation';
import { LoadingState } from 'types/domain/base';
import { EntityTypes } from 'constants/entities';

export interface IThemeReducer {
  themes: ITheme[];
  loading: LoadingState;
  error: string | null;
}

const initialState: IThemeReducer = {
  themes: [],
  loading: LoadingState.DEFAULT,
  error: null,
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setThemes(state, action: PayloadAction<ITheme[]>) {
      state.themes = action.payload;
    },
    updateTheme(state, action: PayloadAction<ITheme>) {
      const index = state.themes.findIndex(t => t.id === action.payload.id);
      if (index !== -1) state.themes[index] = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(listRequest.pending, (state, action) => {
        if (action.meta.arg.type === EntityTypes.THEME) {
          state.loading = LoadingState.LOADING;
          state.error = null;
        }
      })
      .addCase(listRequest.fulfilled, (state, action) => {
        if (action.meta.arg.type === EntityTypes.THEME) {
          state.themes = action.payload;
          state.loading = LoadingState.LOADED;
        }
      })
      .addCase(listRequest.rejected, (state, action) => {
        if (action.meta.arg.type === EntityTypes.THEME) {
          state.loading = LoadingState.ERROR;
          state.error = action.error.message || 'Failed to load themes';
        }
      })
      .addCase(update, (state, action) => {
        if (action.payload.type === EntityTypes.THEME) {
          const index = state.themes.findIndex(t => t.id === action.payload.entity.id);
          if (index !== -1) {
            state.themes[index] = { ...state.themes[index], ...action.payload.entity };
          }
        }
      })
      .addCase(updateRequest.fulfilled, (state, action) => {
        if (action.meta.arg.type === EntityTypes.THEME) {
          const index = state.themes.findIndex(t => t.id === action.payload.id);
          if (index !== -1) state.themes[index] = action.payload;
        }
      });
  },
});

export const { setThemes, updateTheme } = themeSlice.actions;
export default themeSlice.reducer;
